var map = {
	"./1.svg": "237c",
	"./NEWS.svg": "3414",
	"./active.svg": "84ac",
	"./add.svg": "a791",
	"./addressUpdated.svg": "1d80",
	"./android.svg": "b869",
	"./app.svg": "a3cc",
	"./apple.svg": "3664",
	"./back.svg": "862e",
	"./bell.svg": "5b52",
	"./camera.svg": "2188",
	"./chart.svg": "3def",
	"./chat.svg": "92b6",
	"./circle.svg": "c1a0",
	"./circle_1_4.svg": "b59a",
	"./circle_main.svg": "3ed6",
	"./close.svg": "620d",
	"./contact.svg": "ebad",
	"./copy.svg": "197b",
	"./copy2.svg": "486e",
	"./daily.svg": "c83a",
	"./delete.svg": "9c21",
	"./diamond.svg": "f7b1",
	"./digital/box_small.svg": "a8e9",
	"./digital/brackets_big.svg": "bc5b",
	"./digital/brackets_big_left.svg": "63dc",
	"./digital/brackets_big_right.svg": "e89f",
	"./digital/brain.svg": "aecc",
	"./digital/brain_face.svg": "e988",
	"./digital/brain_planet.svg": "c202",
	"./digital/brain_round.svg": "2d6a",
	"./digital/chart_power.svg": "6920",
	"./digital/chart_stage.svg": "53c7",
	"./digital/digital_space_bg_bottom.svg": "e0a7",
	"./digital/digital_space_bg_bottom2.svg": "2596",
	"./digital/digital_space_bg_top.svg": "153c",
	"./digital/digital_space_bg_top2.svg": "bd8e",
	"./digital/digital_tree.svg": "3a99",
	"./digital/digital_tree_ori.svg": "21a5",
	"./digital/digital_wire_bottom.svg": "e4da",
	"./digital/digital_wire_bottom2.svg": "84dc",
	"./digital/digital_wire_top.svg": "5cc0",
	"./digital/digital_wire_top2.svg": "2256",
	"./digital/downhill_line1.svg": "ed0e",
	"./digital/downhill_line2.svg": "1a3f",
	"./digital/downhill_line3.svg": "d087",
	"./digital/downhill_line4.svg": "3bd1",
	"./digital/idcard.svg": "b23a",
	"./digital/idcard_chip.svg": "5fbf",
	"./digital/idcard_input.svg": "1d4b",
	"./digital/idcard_invite.svg": "d281",
	"./digital/idcard_round.svg": "ef8a",
	"./digital/idcard_teamcard.svg": "cd5c",
	"./digital/line_dotted.svg": "c48b",
	"./digital/logo3.svg": "b4ff",
	"./digital/progress_big.svg": "0715",
	"./digital/round1.svg": "1c8b",
	"./digital/round2.svg": "32ed",
	"./digital/round3.svg": "05ca",
	"./digital/stage.svg": "db90",
	"./digital/team_develop.svg": "c7c8",
	"./digital/team_stage.svg": "79b0",
	"./digital/text_blind_box.svg": "995e",
	"./down.svg": "42f5",
	"./download.svg": "3bc2",
	"./edit.svg": "7461",
	"./eye_close.svg": "88b5",
	"./eye_open.svg": "11bb",
	"./file.svg": "a113",
	"./filter.svg": "fae0",
	"./fingerprint.svg": "c143",
	"./fire.svg": "e8c3",
	"./gift.svg": "9285",
	"./home.svg": "c806",
	"./inactive.svg": "2a49",
	"./integral.svg": "fe6c",
	"./left.svg": "a81b",
	"./lineChart.svg": "dc09",
	"./lines.svg": "7fbc",
	"./lock.svg": "d3a2",
	"./lock_white.svg": "2af4",
	"./mine.svg": "c815",
	"./nav_share.svg": "e0e6",
	"./pack.svg": "8787",
	"./paper_airplane.svg": "9092",
	"./peoples.svg": "2b38",
	"./percent.svg": "8e86",
	"./percent2.svg": "e7b8",
	"./product.svg": "d462",
	"./progress_left.svg": "b04c",
	"./progress_right.svg": "03a1",
	"./question.svg": "7db6",
	"./redemption.svg": "1265",
	"./refresh.svg": "0b0b",
	"./right.svg": "ec92",
	"./right_arrow.svg": "7f8d",
	"./robot.svg": "d500",
	"./search.svg": "2f71",
	"./setting.svg": "f977",
	"./tb1.svg": "138e",
	"./telegram.svg": "acf8",
	"./tg.svg": "fcbe",
	"./to_stop_selected.svg": "e5d4",
	"./trend-up.svg": "dd73",
	"./upload.svg": "179e",
	"./video_play.svg": "be50",
	"./vip.svg": "715d",
	"./voice.svg": "24fb",
	"./word.svg": "b23e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c857";